/*
 * Adds extra departments to The Southern Air Import for real stock that
 * doesn't fit any of the site's six built-in ones (All/Field Gear/Uniforms/
 * Aviation/Comms/Load-Bearing — all driven by product.type):
 *
 *   Modern Tactical  current-production tactical gear (HCC Tactical's K19/
 *                    K-Zero SF/Reaper Rig line, etc.) that doesn't belong in
 *                    any of the four vintage Era Archive decades either.
 *   Other            a small catch-all for real stock whose own product.type
 *                    is something else entirely and was never going to have
 *                    a department of its own — e.g. a Mini Museum specimen
 *                    ("Specimens > Relics & Artifacts").
 *   Books            the "Books by splitShops" Collective import — its own
 *                     real product.type is already the clean, exact value
 *                     "Books", so unlike the others this one needs no tag
 *                     or extra bootstrap field at all; it matches directly
 *                     against p.cat, the same field the six built-in
 *                     departments already key off of.
 *   Knives           the JW SteelCrafts / Divine Knives Collective import —
 *                    back to tag-driven like Modern Tactical/Other, since
 *                    these arrived with varied, specific product.types
 *                    ("Kukri Knife", "axes", "Viking Axe", "Bowie knife")
 *                    rather than one shared value the way Books did.
 *
 * Two ways an entry can decide whether a product belongs to it — pick
 * whichever fits the real data:
 *   field:    a tag-driven boolean (see snippets/sat-bootstrap.liquid —
 *             `modern`/`otherDept`), for products whose real product.type
 *             needs to stay untouched (kept additive on purpose: flattening
 *             it into one type would blur real catalog data for no reason).
 *   matchCat: a direct p.cat equality check, for products whose real
 *             product.type is already the exact department name.
 * New departments are just new entries in EXTRA_DEPARTMENTS below — nothing
 * else in this file changes shape to add one.
 *
 * Two small, separate touches rather than one big rewrite:
 *
 * 1. Wraps SATComponent.prototype.visibleProducts so the department filter
 *    recognizes each extra department as a real choice: it filters using
 *    whichever of the two checks above the entry declares, instead of the
 *    built-in system's normal p.cat===activeCat check (matchCat entries
 *    reach the same result through this same field, just spelled out
 *    explicitly rather than relying on activeCat lining up with it by
 *    coincidence). Falls back to the original method for every built-in
 *    department and search.
 *
 * 2. Wraps SATComponent.prototype.renderVals to add one chip per extra
 *    department to the Departments list the sidebar already renders
 *    (out.cats), reusing the exact same shape/styling the base build
 *    computes for its six built-in departments so they're visually
 *    indistinguishable from them.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var EXTRA_DEPARTMENTS = [
    { label: 'Modern Tactical', field: 'modern' },
    { label: 'Other', field: 'otherDept' },
    { label: 'Books', matchCat: 'Books' },
    { label: 'Knives', field: 'isKnife' }
  ];
  var LABEL_TO_DEPT = {};
  EXTRA_DEPARTMENTS.forEach(function (d) { LABEL_TO_DEPT[d.label] = d; });

  function belongsTo(p, d) {
    return d.matchCat ? p.cat === d.matchCat : !!p[d.field];
  }

  var proto = window.SATComponent.prototype;

  var origVisibleProducts = proto.visibleProducts;
  proto.visibleProducts = function () {
    var dept = LABEL_TO_DEPT[this.state.activeCat];
    if (!dept) {
      return origVisibleProducts.call(this);
    }
    var q = String(this.state.query || '').trim().toLowerCase();
    var list = this._products.filter(function (p) {
      var catOk = belongsTo(p, dept);
      var qOk = !q || (p.name + ' ' + p.cat + ' ' + p.era + ' ' + p.id + ' ' + p.blurb).toLowerCase().indexOf(q) !== -1;
      return catOk && qOk;
    });
    if (this.state.sortBy === 'Price, Low to High') { list = list.slice().sort(function (a, b) { return a.price - b.price; }); }
    if (this.state.sortBy === 'Price, High to Low') { list = list.slice().sort(function (a, b) { return b.price - a.price; }); }
    if (this.state.sortBy === 'Oldest Era') { list = list.slice().sort(function (a, b) { return a.era.localeCompare(b.era); }); }
    return list;
  };

  var origRenderVals = proto.renderVals;
  proto.renderVals = function () {
    var out = origRenderVals.call(this);
    var self = this;
    var s = this.state;
    if (!Array.isArray(out.cats)) { return out; }
    var extraChips = EXTRA_DEPARTMENTS.map(function (d) {
      var active = s.activeCat === d.label;
      return {
        label: d.label,
        style: active ? 'background:#1A1A18;color:#EFEDE6;' : 'background:transparent;color:#1A1A18;',
        tick: active ? '✕' : '',
        chipDark: active
          ? 'background:#F0C77A;color:#232E38;border:1px solid #F0C77A;'
          : 'background:rgba(244,239,227,.06);color:#DDD5C4;border:1px solid rgba(240,199,122,.35);',
        chip: active
          ? 'background:#232E38;color:#F4EFE3;border:1px solid #232E38;'
          : 'background:transparent;color:#232E38;border:1px solid rgba(35,46,56,.3);',
        pick: function () { self.setState({ activeCat: d.label }); self.siteClick(); }
      };
    });
    out.cats = out.cats.concat(extraChips);
    return out;
  };
})();
